import React from 'react';
import StatePickerMenu from 'flow/components/tickets/State/StatePickerMenu';
import useUpdateTicketState from 'flow/components/tickets/State/useUpdateTicketState';
import { TicketKey } from 'flow/types/EntityKeys';

type Props = {
    ticketKey: TicketKey;
};

// Rendered only while the chip's menu is open, so the status-change wiring
// (dispatch, request state) only exists when it can actually be used.
const StatusChipPicker = ({ ticketKey }: Props) => {
    const { onSelect } = useUpdateTicketState(ticketKey, 'tickets list');

    return <StatePickerMenu onSelect={onSelect} anchor="bottom start" />;
};

export default React.memo(StatusChipPicker);
